// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterClinic_root__1W0zi"};